export default {
  methods: {
    priceFormat(value) {
      if (!value || Number.isNaN(value)) {
        return "";
      }
      const hasDecimals = value % 1 !== 0;
      return hasDecimals ? value.toFixed(2) : value;
    },

    findPriceOrDefault(product, priceType, currencyCode) {
      const defaultPrice = { currency: currencyCode, amount: 0 };
      if (!product || !product[priceType]) {
        return defaultPrice;
      }
      let price = product[priceType].find(
        i => i.currency.toUpperCase() === currencyCode.toUpperCase()
      );
      if (!price) {
        return defaultPrice;
      }
      return price;
    }
  }
};
